<template>
	 <v-container>
    <v-flex xs12 sm6 offset-sm3>
      <v-card v-if='!verifiedEmail' color='primary'>
        <v-card-title primary-title>
          <div class="headline">
            Please Verifiy Email Address
          </div>
        </v-card-title>
        <div>
          {{emailAddress}}
        </div>
        <v-card-actions >
          <v-btn color='success' @click='verify'>Send Verification Email</v-btn>
        </v-card-actions>
      </v-card>
  </v-flex>
</v-container>
</template>
<script>
import {mapGetters, mapActions} from 'vuex'
export default {
  data () {
    return {
    }
  },
  computed: {
    ...mapGetters('user', {
      verifiedEmail: 'emailVerified',
      emailAddress: 'emailAddress'
    })
  },
  methods: {
    ...mapActions('user', {
      verify: 'sendVerificationEmail'
    })
  }
}
</script>


// WEBPACK FOOTER //
// src/components/user/VerifyEmail.vue